export const LOGIN_ROUTE = '/login'
export const OVERVIEW_ROUTE = '/overview'